import { render, staticRenderFns } from "./RatiosForm.vue?vue&type=template&id=1c5247a2&"
import script from "./RatiosForm.vue?vue&type=script&lang=js&"
export * from "./RatiosForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports